module.exports = __webpack_public_path__ + "static/media/Transfer_Start.1f65d857.png";